import { useEffect, useMemo, useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/dashboard";
    api.post("/auth/session", { session_id: sessionId })
      .then(r => {
        setUser(r.data);
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: r.data } });
      })
      .catch(() => setError("Google sign-in could not be completed. Please try again."));
  }, [location, navigate, setUser]);

  const errState = error ? { error } : null;
  if (errState) return <Navigate to="/login" replace state={errState} />;
  return <div className="min-h-screen flex items-center justify-center text-sm text-stone-500" data-testid="auth-callback">Signing you in…</div>;
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const fromState = useMemo(() => ({ from: location.pathname }), [location.pathname]);
  if (loading && !location.state?.user) return <div className="min-h-screen flex items-center justify-center text-sm text-stone-500" data-testid="auth-loading">Loading…</div>;
  if (!user && !location.state?.user) return <Navigate to="/login" replace state={fromState} />;
  return children;
}
